// extracted by mini-css-extract-plugin
module.exports = {"u1q7q435":"u1q7q435","l1a7exmc":"l1a7exmc"};